/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Hungarian
export default {
    'fabric.atlassianSwitcher.switchTo': 'Átváltás erre:',
    'fabric.atlassianSwitcher.switchToTooltip': 'Átváltás erre...',
    'fabric.atlassianSwitcher.recent': 'Legutóbbi',
    'fabric.atlassianSwitcher.more': 'Továbbiak',
    'fabric.atlassianSwitcher.try': 'Próbálja ki',
    'fabric.atlassianSwitcher.manageList': 'Lista kezelése',
    'fabric.atlassianSwitcher.jiraProject': 'Jira projekt',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-munkatér',
    'fabric.atlassianSwitcher.people': 'Személyek',
    'fabric.atlassianSwitcher.administration': 'Adminisztráció',
    'fabric.atlassianSwitcher.discoverMore': 'Továbbiak felfedezése',
    'fabric.atlassianSwitcher.errorHeading': 'Valami baj történt',
    'fabric.atlassianSwitcher.errorText': 'Nyomon követjük az ilyen hibákat, de bátran vegye fel velünk a kapcsolatot, ha az oldal frissítésével sem oldódnak meg a problémák.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Meghibásodott robot, és számos ember, aki a javításán szorgoskodik.',
    'fabric.atlassianSwitcher.expand': 'Kibontás',
};
//# sourceMappingURL=hu.js.map